/* eslint-disable */
import React, { useEffect, useState } from 'react'
import Head from 'next/head'
import Footer from '../../components/Footer'
import FooterArchievement from '../../components/Footer/FooterArchievement'
import AboutBlock from '../../components/AboutBlock'
import ConvertSteps from '../../components/ConvertSteps'
import { getProductSchemes } from '../../components/Schema/ProductSchema'
import TopConversionsTable from '../../components/TopConversions'
import GoogleAdsense from '../../components/Ads/GoogleAdsense'
import getDeviceConfig from '../../hooks/Breakpoint'

import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'next-i18next'
import { fetchStatistics, fetchUsageInfo } from '../../redux/actions/file_list'
import { NextSeo } from 'next-seo'
import HeaderBar from '../../components/HeaderBar'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import DragDropContainer from '../../components/DragDrop/DragDropContainer'

const AudioConverter = ({ type }) => {
  const [adsOffset, setAdsOffset] = useState(1000)
  const { isXl, isXxl } = getDeviceConfig()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const formatsState = useSelector(state => state.formats)
  const { usage, statistic } = useSelector(state => state.fileList)
  const [fromFile, setFromFile] = useState('')
  const [toFile, setToFile] = useState('')
  const schemaData = {
    id: `online-${type}-converter`,
    name: `Online ${type} Converter`,
    description: `Free convert ${type.toLowerCase()} with online software app by Evano.`,
    image: [`/images/icon_${type.toLowerCase()}_converter_fag.svg`],
    ratingValue: 4.5,
    ratingCount: 1609
  }

  useEffect(() => {
    // setFromFile(formatsState.formats.from)
    // setToFile(formatsState.formats.to)
    switch(type.toLowerCase()) {
      case 'audio':
        setFromFile('MP3')
        setToFile('WAV')
        return
      case 'video':
        setFromFile('MP4')
        setToFile('AVI')
        return
      case 'font':
        setFromFile('TTF')
        setToFile('WOFF')
        return
      case 'document':
      case 'text':
        setFromFile('PDF')
        setToFile('DOCX')
        return
      case 'presentation':
        setFromFile('PPT')
        setToFile('POT')
        return
      case 'archive':
        setFromFile('RAR')
        setToFile('ZIP')
        return
      case 'image':
        setFromFile('PNG')
        setToFile('JPG')
        return
      default:
          setFromFile('MP4')
          setToFile('AVI')
          return
    }
  }, [type])

  useEffect(() => {
    try {
      dispatch(fetchUsageInfo())
      dispatch(fetchStatistics())
    } catch (error) {
      console.log(error);
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const handleScroll = () => {
    const adsContainer = document.querySelector('div.ads_container')
    if (adsContainer) {
      const distanceScroll = document.body.scrollTop
      const elRect = adsContainer.getBoundingClientRect()
      const elOffset = elRect.top
      setAdsOffset(distanceScroll + elOffset)
    }
  }

  return (
    <>
      <NextSeo
        title={`Online ${type} Converter`}
        description={`Free convert ${type.toLowerCase()} with online software app by Evano.`}
        canonical = {`https://evano.com/online-${type.toLowerCase()}-converter`}
        openGraph= {{
          title: `Online ${type} Converter`,
          url: `https://evano.com/online-${type.toLowerCase()}-converter`,
        }}
      />
      <Head>
        <title>{ type } Converter</title>
        {getProductSchemes(schemaData)}
      </Head>
      <HeaderBar />

      <DragDropContainer type='audio' dragDropTitle={t('audio-converter:audio_converter', { type })} title={formatsState.formats.from && formatsState.formats.from !== '' ? `Convert ${formatsState.formats.from.toUpperCase()}` : `Convert Any ${type} File`} dragDropSubtitle={t('audio-converter:convert_your_file')}/>

      <section style={{ position: 'relative' }}>
        <div className='ads_container mx-auto p-minus' style={{position: 'relative'}}>
          <div key='v__adsbygoogle_left' className={`v__adsbygoogle left ${adsOffset < 676 ? 'fixed' : ''}`}>
            { isXl || isXxl ? (<GoogleAdsense
              className="adsbygoogle"
              style={{display: 'inline-block', 'min-width': '200px', 'min-height': '50px'}}
              client='ca-pub-6022273213615485'
              slot='6680291945'
              format='auto'
              responsive={true} />) : null }
          </div>
          <ConvertSteps fromFile={(fromFile || 'MP4').toUpperCase()}
            toFile={(toFile || 'AVI').toUpperCase()}
            title={`How to convert ${(fromFile || 'MP4').toUpperCase()} to ${(toFile || 'AVI').toUpperCase()}`}
            action='Convert'/>
          <div key='v__adsbygoogle_right' className={`v__adsbygoogle right ${adsOffset < 676 ? 'fixed' : ''}`}>
            { isXl || isXxl ? (<GoogleAdsense
              className="adsbygoogle"
              style={{display: 'inline-block', 'min-width': '200px', 'min-height': '50px'}}
              client='ca-pub-6022273213615485'
              slot='6680291945'
              format='auto'
              responsive={true} />) : null }
          </div>
        </div>
      </section>
      <AboutBlock
        type={type}
        about={{ title: t('audio-converter:about_title', {type}), text: t('audio-converter:about_text') }}
        editor={{ title: t('audio-converter:editor_title', {type}), text: t('audio-converter:editor_text'), icon: require('public/images/icon_audio_editor.svg') }}
        button={{ text: t('audio-converter:try_now'), href: `/online-${type.toLowerCase()}-converter`}}
      />
      {/* <SupportedFormatTable type={type} /> */}
      <TopConversionsTable />
      <section className='pre_footer'>
      { statistic ? <FooterArchievement totalFile={statistic.total_file} totalFileSize={statistic.total_file_size}/> : null }
      </section>
      <Footer />
    </>
  )
}

export const getStaticProps = async (ctx) => {
  const paths = ctx.params.type || 'online-audio-converter'
  const types = paths.split('-')
  const type = types.length > 0 ? types[1] : 'Audio'
  return {
    props: {      ...(await serverSideTranslations('en', ['common', 'footer', 'header'])),
      type: type.replace(/^./, type[0].toUpperCase())
    }
  }
}

export async function getStaticPaths() {
  const types = ['video', 'audio', 'text', 'image', 'document', 'presentation', 'ebook', 'archive']
  return {
    paths: types.map(type => {
      return {
        params: {
          type: `online-${type}-converter`
        }
      }
    }),
    fallback: false
  }
}

export default AudioConverter
